export const COMPANY_TYPES = {
  INTERNAL: 'Internal',
  PARTNER: 'Partner'
};

export const getCompanyTypeColor = (type) => {
  switch (type) {
    case COMPANY_TYPES.INTERNAL:
      return '#EBF5FF';
    case COMPANY_TYPES.PARTNER:
      return '#F3E8FF';
    default:
      return '#F3F4F6';
  }
};

export const getCompanyTypeTextColor = (type) => {
  switch (type) {
    case COMPANY_TYPES.INTERNAL:
      return '#1D4ED8';
    case COMPANY_TYPES.PARTNER:
      return '#7C3AED';
    default:
      return '#6B7280';
  }
};
